import {
  Dispatch,
  isRejectedWithValue,
  Middleware,
  PayloadAction,
  UnknownAction,
} from '@reduxjs/toolkit'

// import { notification } from '@/features/notifications/slice'

type RejectedObject = {
  data: { success: false; message: string }
  status: number
}

const getErrorMessage = (status: number) => {
  switch (status) {
    case 400: {
      return 'Oops, something went wrong. Please contact product support'
    }

    // TODO: check if this is needed
    case 404: {
      return ''
    }

    case 500: {
      return 'Oops, system error. Please contact product support'
    }

    default: {
      return ''
    }
  }
}

const apiErrorMiddleware: Middleware<
  unknown,
  unknown,
  Dispatch<UnknownAction>
> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const payloadAction = action as PayloadAction<
      RejectedObject,
      string,
      { arg: { type: string } }
    >

    if (
      isRejectedWithValue(payloadAction) &&
      payloadAction.payload.status >= 400 &&
      payloadAction.meta.arg.type === 'query'
    ) {
      console.error(action)

      // const message = getErrorMessage(payloadAction.payload.status)

      // if (message) {
      //   dispatch(notification.send({ message, variant: 'error' }))
      // }
    }

    return next(action)
  }

export default apiErrorMiddleware
